export enum DataTypeLti {
  ConsumingPlatform = 'lti-consuming-platforms',
  ConsumedTool = 'lti-consumed-tools',
  ConsumedToolDeployment = 'lti-consumed-tool-deployments',
  ResourceLink = 'lti-resource-links',
}
